import { v4 as uuidv4 } from "uuid";
import { request } from "services/request";

const EVENT_URL = "/api/admin/activity/event";
const TAB_ID_KEY = "adminActivityTabId";
const HEARTBEAT_MS = 30 * 1000;
const STATE_CHECK_MS = 5 * 1000;
const IDLE_MS = 2 * 60 * 1000;
const INPUT_EVENTS = ["mousemove", "mousedown", "keydown", "wheel", "scroll", "touchstart"];

const getTabId = () => {
  try {
    let tabId = sessionStorage.getItem(TAB_ID_KEY);
    if (!tabId) {
      tabId = uuidv4();
      sessionStorage.setItem(TAB_ID_KEY, tabId);
    }
    return tabId;
  } catch (e) {
    return uuidv4();
  }
};

let history = null;
let tabId = null;
let active = false;
let lastInputAt = Date.now();
let queue = Promise.resolve();

const isActive = () =>
  document.visibilityState === "visible" &&
  document.hasFocus() &&
  Date.now() - lastInputAt < IDLE_MS;

const event = (extra = {}) => ({
  tabId,
  path: history.location.pathname,
  active,
  ...extra,
});

const send = () => {
  const body = event();
  queue = queue.then(() => request.post(EVENT_URL, body)).catch(() => {});
};

const checkState = () => {
  const next = isActive();
  if (next === active) return;

  active = next;
  send();
};

const onInput = () => {
  lastInputAt = Date.now();
  if (!active) checkState();
};

const onPageHide = () => {
  if (!navigator.sendBeacon) return;

  navigator.sendBeacon(
    `${process.env.REACT_APP_API_URL}${EVENT_URL}`,
    new Blob([JSON.stringify(event({ active: false, closed: true }))], {
      type: "text/plain",
    })
  );
};

export const startAdminActivity = (nextHistory) => {
  if (history) return;

  history = nextHistory;
  tabId = getTabId();
  active = isActive();

  history.listen(() => send());
  INPUT_EVENTS.forEach((eventName) =>
    window.addEventListener(eventName, onInput, { passive: true, capture: true })
  );
  window.addEventListener("focus", checkState);
  window.addEventListener("blur", checkState);
  document.addEventListener("visibilitychange", checkState);
  window.addEventListener("pagehide", onPageHide);
  setInterval(checkState, STATE_CHECK_MS);
  setInterval(send, HEARTBEAT_MS);

  send();
};
